import * as Yup from "yup";

export interface ICreateEnvironment{
  name: string;
  description: string;
  baseUrl: string;
  username: string;
  password: string;
  active: boolean;
  environmentType?: EEnvironmentType;
}

export interface IEnvironmentContext {
  // eslint-disable-next-line no-unused-vars
  getEnvironmentTokenById: (environment: IEnvironment) => Promise<string>;
}

export interface IEnvironment {
  id?: number;
  name?: string;
  description?: string;
  baseUrl?: string;
  username?: string;
  password?: string;
  active?: boolean;
  token?: string;
  environmentType?: EEnvironmentType;
}

export interface IEnvironmentRequestTO {
  name?: string | string[];
  description?: string;
  baseUrl?: string;
  username?: string;
  active?: boolean;
  environmentType?: EEnvironmentType;
}

export enum EFilterColumns {
  // eslint-disable-next-line no-unused-vars
  NAME = "Nome", URL = "Url", USER = "Usuário", ENVIRONMENT_TYPE = "Tipo", STATUS = "Status"
}

export enum EEnvironmentType{
  // eslint-disable-next-line no-unused-vars
  PRD= "PRD", HML = "HML", DEV = "DEV"
}
export const environmentValidationSchema = Yup.object({
  username: Yup.string().required("Usuário : Campo obrigatório"),
  name: Yup.string().required("Nome : Campo obrigatório"),
  baseUrl: Yup.string().required("URL : Campo obrigatório"),
  description: Yup.string().required("Descrição : Campo obrigatório"),
  password: Yup.string().required("Senha : Campo obrigatório"),
  active: Yup.boolean().required("Status : Campo obrigatório"),
  environmentType: Yup.string().required("Tipo do Environment : Campo obrigatório"),
});
